import { colors } from '@ardoq/design-tokens';

const ArchimateShapes = () => (
  <>
    <g id="__archimate-rect" stroke={colors.grey900} strokeWidth="0.75">
      <rect x="0" y="0" width="340" height="140" />
    </g>

    <g id="__archimate-rounded-rect" stroke={colors.grey900} strokeWidth="0.75">
      <path d="M 25.5, 0.5 h 289 a 25,25 0 0 1 25,25 v 89 a 25,25 0 0 1 -25,25 h -289 a 25,25 0 0 1 -25,-25 v -89 a 25,25 0 0 1 25,-25 z" />
    </g>

    <g id="__archimate-wave-rect" stroke={colors.grey900} strokeWidth="0.5">
      <path d="M 0 0 h 400 v 130 c -200,-90 -200,90 -400,0 v -130 z" />
    </g>

    <g id="__archimate-3d-rect" stroke={colors.grey900} strokeWidth="1">
      <path
        d="M 0.5 30.5 l 30 -30 H 399.5 V 129.5 l -30 30 H 0.5 z"
        style={{ strokeLinecap: 'round', strokeLinejoin: 'round' }}
      />
      <path
        d="M 0.5 30.5 H 369.5 V 159.01 M 369.5 30.5 l 30 -30"
        style={{
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          fill: 'none',
        }}
      />
    </g>

    <svg
      viewBox="0 0 340 140"
      id="archimate-rect-component"
      data-label="Rectangle (Component)"
    >
      <use xlinkHref="#__archimate-rect"></use>
      <use
        transform="translate(240, 5)"
        color={colors.grey900}
        height="80px"
        width="80px"
        xlinkHref="#archimate-component-icon"
      ></use>
    </svg>

    <svg
      viewBox="0 0 340 140"
      id="archimate-rect-collaboration"
      data-label="Rectangle (Collaboration)"
    >
      <use xlinkHref="#__archimate-rect"></use>
      <use
        transform="translate(240, 15)"
        color={colors.grey900}
        height="80px"
        width="80px"
        xlinkHref="#archimate-collaboration-icon"
      ></use>
    </svg>

    <svg
      viewBox="0 0 340 140"
      id="archimate-rect-interface"
      data-label="Rectangle (Interface)"
    >
      <use xlinkHref="#__archimate-rect" />
      <use
        transform="translate(240, 10)"
        color={colors.grey900}
        height="80px"
        width="80px"
        xlinkHref="#archimate-interface-icon"
      />
    </svg>

    <svg
      viewBox="0 0 340 140"
      id="archimate-rect-actor"
      data-label="Rectangle (Actor)"
    >
      <use xlinkHref="#__archimate-rect"></use>
      <use
        transform="translate(240, 15)"
        color={colors.grey900}
        height="80px"
        width="80px"
        xlinkHref="#archimate-actor-icon"
      ></use>
    </svg>

    <svg
      viewBox="0 0 340 140"
      id="archimate-rect-role"
      data-label="Rectangle (Role)"
    >
      <use xlinkHref="#__archimate-rect"></use>
      <use
        transform="translate(240, 15)"
        color={colors.grey900}
        height="80px"
        width="80px"
        xlinkHref="#archimate-role-icon"
      ></use>
    </svg>

    <svg
      viewBox="0 0 340 140"
      id="archimate-rect-artifact"
      data-label="Rectangle (Artifact)"
    >
      <use xlinkHref="#__archimate-rect"></use>
      <use
        transform="translate(240, 15)"
        color={colors.grey900}
        height="80px"
        width="80px"
        xlinkHref="#archimate-artifact-icon"
      ></use>
    </svg>

    <svg
      viewBox="0 0 340 140"
      id="archimate-rect-node"
      data-label="Rectangle (Node)"
    >
      <use xlinkHref="#__archimate-rect"></use>
      <use
        transform="translate(240, 15)"
        color={colors.grey900}
        height="80px"
        width="80px"
        xlinkHref="#archimate-node-icon"
      ></use>
    </svg>

    <svg
      viewBox="0 0 340 140"
      id="archimate-rect-system-software"
      data-label="Rectangle (System Software)"
    >
      <use xlinkHref="#__archimate-rect"></use>
      <use
        transform="translate(240, 15)"
        color={colors.grey900}
        height="80px"
        width="80px"
        xlinkHref="#archimate-system-software-icon"
      ></use>
    </svg>

    <svg
      viewBox="0 0 340 140"
      id="archimate-rect-path"
      data-label="Rectangle (Path)"
    >
      <use xlinkHref="#__archimate-rect"></use>
      <use
        transform="translate(240, 15)"
        color={colors.grey900}
        height="80px"
        width="80px"
        xlinkHref="#archimate-path-icon"
      ></use>
    </svg>

    <svg
      viewBox="0 0 340 140"
      id="archimate-rect-communication-network"
      data-label="Rectangle (Communication Network)"
    >
      <use xlinkHref="#__archimate-rect"></use>
      <use
        transform="translate(240, 15)"
        color={colors.grey900}
        height="80px"
        width="80px"
        xlinkHref="#archimate-communication-network-icon"
      ></use>
    </svg>

    <svg
      viewBox="0 0 340 140"
      id="archimate-rect-resource"
      data-label="Rectangle (Resource)"
    >
      <use xlinkHref="#__archimate-rect"></use>
      <use
        transform="translate(240, 15)"
        color={colors.grey900}
        height="80px"
        width="80px"
        xlinkHref="#archimate-resource-icon"
      ></use>
    </svg>

    <svg
      viewBox="0 0 340 140"
      id="archimate-rect-distribution-network"
      data-label="Rectangle (Distribution Network)"
    >
      <use xlinkHref="#__archimate-rect"></use>
      <use
        transform="translate(240, 15)"
        color={colors.grey900}
        height="80px"
        width="80px"
        xlinkHref="#archimate-distribution-network-icon"
      ></use>
    </svg>

    <svg
      viewBox="0 0 340 140"
      id="archimate-rect-location"
      data-label="Rectangle (Location)"
    >
      <use xlinkHref="#__archimate-rect"></use>
      <use
        transform="translate(250,0)"
        color={colors.grey900}
        height="80px"
        width="80px"
        xlinkHref="#archimate-location-icon"
      ></use>
    </svg>

    <svg
      viewBox="0 0 340 140"
      id="archimate-rect-material"
      data-label="Rectangle (Material)"
    >
      <use xlinkHref="#__archimate-rect"></use>
      <use
        transform="translate(240, 15)"
        color={colors.grey900}
        height="80px"
        width="80px"
        xlinkHref="#archimate-material-icon"
      ></use>
    </svg>

    <svg
      viewBox="0 0 340 140"
      id="archimate-rounded-rect"
      data-label="Rounded Rectangle"
    >
      <use xlinkHref="#__archimate-rounded-rect"></use>
    </svg>

    <svg
      viewBox="0 0 340 140"
      id="archimate-rounded-rect-function"
      data-label="Rounded Rectangle (Function)"
    >
      <use xlinkHref="#__archimate-rounded-rect"></use>
      <use
        transform="translate(240, 15)"
        color={colors.grey900}
        height="80px"
        width="80px"
        xlinkHref="#archimate-function-icon"
      ></use>
    </svg>

    <svg
      viewBox="0 0 340 140"
      id="archimate-rounded-rect-interaction"
      data-label="Rounded Rectangle (Interaction)"
    >
      <use xlinkHref="#__archimate-rounded-rect"></use>
      <use
        transform="translate(240, 15)"
        color={colors.grey900}
        height="80px"
        width="80px"
        xlinkHref="#archimate-interaction-icon"
      ></use>
    </svg>

    <svg
      viewBox="0 0 340 140"
      id="archimate-rounded-rect-process"
      data-label="Rounded Rectangle (Process)"
    >
      <use xlinkHref="#__archimate-rounded-rect"></use>
      <use
        transform="translate(240, 0)"
        color={colors.grey900}
        height="80px"
        width="80px"
        xlinkHref="#archimate-process-icon"
      ></use>
    </svg>

    <svg
      viewBox="0 0 340 140"
      id="archimate-rounded-rect-event"
      data-label="Rounded Rectangle (Event)"
    >
      <use xlinkHref="#__archimate-rounded-rect"></use>
      <use
        transform="translate(240, 15)"
        color={colors.grey900}
        height="80px"
        width="80px"
        xlinkHref="#archimate-event-icon"
      ></use>
    </svg>

    <svg
      viewBox="0 0 340 140"
      id="archimate-rounded-rect-service"
      data-label="Rounded Rectangle (Service)"
    >
      <use xlinkHref="#__archimate-rounded-rect"></use>
      <use
        transform="translate(240, 15)"
        color={colors.grey900}
        height="80px"
        width="80px"
        xlinkHref="#archimate-service-icon"
      ></use>
    </svg>

    <svg
      viewBox="0 0 340 140"
      id="archimate-rounded-rect-stakeholder"
      data-label="Rounded Rectangle (Stakeholder)"
    >
      <use xlinkHref="#__archimate-rounded-rect"></use>
      <use
        transform="translate(240, 15)"
        color={colors.grey900}
        height="80px"
        width="80px"
        xlinkHref="#archimate-stakeholder-icon"
      ></use>
    </svg>

    <svg
      viewBox="0 0 340 140"
      id="archimate-rounded-rect-driver"
      data-label="Rounded Rectangle (Driver)"
    >
      <use xlinkHref="#__archimate-rounded-rect"></use>
      <use
        transform="translate(240, 15)"
        color={colors.grey900}
        height="80px"
        width="80px"
        xlinkHref="#archimate-driver-icon"
      ></use>
    </svg>

    <svg
      viewBox="0 0 340 140"
      id="archimate-rounded-rect-assessment"
      data-label="Rounded Rectangle (Assessment)"
    >
      <use xlinkHref="#__archimate-rounded-rect"></use>
      <use
        transform="translate(240, 15)"
        color={colors.grey900}
        height="80px"
        width="80px"
        xlinkHref="#archimate-assessment-icon"
      ></use>
    </svg>

    <svg
      viewBox="0 0 340 140"
      id="archimate-rounded-rect-goal"
      data-label="Rounded Rectangle (Goal)"
    >
      <use xlinkHref="#__archimate-rounded-rect"></use>
      <use
        transform="translate(240, 15)"
        color={colors.grey900}
        height="80px"
        width="80px"
        xlinkHref="#archimate-goal-icon"
      ></use>
    </svg>

    <svg
      viewBox="0 0 340 140"
      id="archimate-rounded-rect-outcome"
      data-label="Rounded Rectangle (Outcome)"
    >
      <use xlinkHref="#__archimate-rounded-rect"></use>
      <use
        transform="translate(240, 15)"
        color={colors.grey900}
        height="80px"
        width="80px"
        xlinkHref="#archimate-outcome-icon"
      ></use>
    </svg>

    <svg
      viewBox="0 0 340 140"
      id="archimate-rounded-rect-principle"
      data-label="Rounded Rectangle (Principle)"
    >
      <use xlinkHref="#__archimate-rounded-rect"></use>
      <use
        transform="translate(240, 15)"
        color={colors.grey900}
        height="80px"
        width="80px"
        xlinkHref="#archimate-principle-icon"
      ></use>
    </svg>

    <svg
      viewBox="0 0 340 140"
      id="archimate-rounded-rect-requirement"
      data-label="Rounded Rectangle (Requirement)"
    >
      <use xlinkHref="#__archimate-rounded-rect"></use>
      <use
        transform="translate(240, 5)"
        color={colors.grey900}
        height="80px"
        width="80px"
        xlinkHref="#archimate-requirement-icon"
      ></use>
    </svg>

    <svg
      viewBox="0 0 340 140"
      id="archimate-rounded-rect-constraint"
      data-label="Rounded Rectangle (Constraint)"
    >
      <use xlinkHref="#__archimate-rounded-rect"></use>
      <use
        transform="translate(240, 5)"
        color={colors.grey900}
        height="80px"
        width="80px"
        xlinkHref="#archimate-constraint-icon"
      ></use>
    </svg>

    <svg
      viewBox="0 0 340 140"
      id="archimate-rounded-rect-capability"
      data-label="Rounded Rectangle (Capability)"
    >
      <use xlinkHref="#__archimate-rounded-rect"></use>
      <use
        transform="translate(240, 15)"
        color={colors.grey900}
        height="80px"
        width="80px"
        xlinkHref="#archimate-capability-icon"
      ></use>
    </svg>

    <svg
      viewBox="0 0 340 140"
      id="archimate-rounded-rect-course-of-action"
      data-label="Rounded Rectangle (Course of Action)"
    >
      <use xlinkHref="#__archimate-rounded-rect"></use>
      <use
        transform="translate(240, 10)"
        color={colors.grey900}
        height="80px"
        width="80px"
        xlinkHref="#archimate-course-of-action-icon"
      ></use>
    </svg>

    <svg
      viewBox="0 0 340 140"
      id="archimate-rounded-rect-value-stream"
      data-label="Rounded Rectangle (Value Stream)"
    >
      <use xlinkHref="#__archimate-rounded-rect"></use>
      <use
        transform="translate(240, 5)"
        color={colors.grey900}
        height="80px"
        width="80px"
        xlinkHref="#archimate-value-stream-icon"
      ></use>
    </svg>

    <svg
      viewBox="0 0 400 155.98"
      id="archimate-wave-rect"
      data-label="Wavy Rectangle"
    >
      <use xlinkHref="#__archimate-wave-rect"></use>
    </svg>

    <svg
      viewBox="0 0 400 155.98"
      id="archimate-wave-rect-gap"
      data-label="Wavy Rectangle (Gap)"
    >
      <use xlinkHref="#__archimate-wave-rect"></use>
      <use
        transform="translate(300,0)"
        color={colors.grey900}
        height="80px"
        width="80px"
        xlinkHref="#archimate-gap-icon"
      ></use>
    </svg>

    <svg
      viewBox="0 0 400 160"
      id="archimate-3d-rect-plateau"
      data-label="3D Rectangle (Plateau)"
    >
      <use xlinkHref="#__archimate-3d-rect"></use>
      <use
        transform="translate(270,30)"
        color={colors.grey900}
        height="80px"
        width="80px"
        xlinkHref="#archimate-plateau-icon"
      ></use>
    </svg>

    <svg
      viewBox="0 0 400 160"
      id="archimate-3d-rect-device"
      data-label="3D Rectangle (Device)"
    >
      <use xlinkHref="#__archimate-3d-rect"></use>
      <use
        transform="translate(270,30)"
        color={colors.grey900}
        height="80px"
        width="80px"
        xlinkHref="#archimate-device-icon"
      ></use>
    </svg>

    <svg
      viewBox="0 0 400 160"
      id="archimate-3d-rect-facility"
      data-label="3D Rectangle (Facility)"
    >
      <use xlinkHref="#__archimate-3d-rect"></use>
      <use
        transform="translate(270,30)"
        color={colors.grey900}
        height="80px"
        width="80px"
        xlinkHref="#archimate-facility-icon"
      ></use>
    </svg>

    <svg
      viewBox="0 0 400 160"
      id="archimate-3d-rect-equipment"
      data-label="3D Rectangle (Equipment)"
    >
      <use xlinkHref="#__archimate-3d-rect"></use>
      <use
        transform="translate(270,30)"
        color={colors.grey900}
        height="80px"
        width="80px"
        xlinkHref="#archimate-equipment-icon"
      ></use>
    </svg>

    <svg
      viewBox="1280 2331.67 340 140"
      id="archimate-object"
      data-label="Object"
      stroke="#000"
      strokeWidth="1"
    >
      <path d="M 1280 2361.67 h 340 v -30 h -340 v 140 h 340 v -110" />
    </svg>

    <svg
      viewBox="1280 2331.67 340 140"
      id="archimate-contract"
      data-label="Contract"
      stroke="#000"
      strokeWidth="1"
    >
      <path d="M 1280 2361.67 h 340 v -30 h -340 v 140 h 340 v -110" />
      <path d="M 1280 2361.67 h 340 v -30 h -340 v 110 h 340 v -110" />
    </svg>

    <svg
      viewBox="540 2674.17 340 155.98"
      id="archimate-representation"
      data-label="Representation"
      stroke="#000"
      strokeWidth="1"
    >
      <path d="M 540 2674.17 h 340 v 130 c -170,-90 -170,90 -340,0 v -130 z" />
    </svg>

    <svg
      viewBox="540 2857.5 340 140"
      id="archimate-product"
      data-label="Product"
      stroke="#000"
      strokeWidth="1"
    >
      <rect x="540" y="2857.50" width="340" height="140" />
      <path style={{ fill: 'none' }} d="M 710 2857.50 v 30 h -170" />
    </svg>

    <svg
      viewBox="180 700 400 160"
      id="archimate-oval-circle"
      data-label="Oval Circle"
      stroke="#000"
      strokeWidth="1"
    >
      <ellipse cx="380" cy="780" rx="200" ry="80" />
    </svg>

    <svg
      viewBox="182.45 901.6 396.75 157.97"
      id="archimate-cloud"
      data-label="Cloud"
      stroke="#000"
      strokeWidth="1"
    >
      <g transform="translate(180, 900) scale(1.142857,0.661157) translate(-194, -251)">
        <path d="M 220,332.36 C 170,272.36 240,242.36 280,272.36 C 290,242.36 350,252.36 360,272.36 C 390,252.36 480,252.36 480,272.36 C 540,252.36 560,332.36 520,352.36 C 560,352.36 540.67,407.98 520,432.36 C 520,512.36 440,492.36 400,472.36 C 360,492.36 200,512.36 240,452.36 C 180,452.36 190,332.36 220,332.36 z" />
      </g>
    </svg>

    <svg
      viewBox="-104 -104 250 250"
      id="archimate-and"
      data-label="Junction (And)"
    >
      <circle
        fill="black"
        strokeWidth="1"
        stroke="black"
        r="20"
        cy="22"
        cx="22"
        height="200"
        width="200"
      ></circle>
    </svg>

    <svg
      viewBox="-104 -104 250 250"
      id="archimate-or"
      data-label="Junction (Or)"
    >
      <circle
        fill="white"
        strokeWidth="1"
        stroke="black"
        r="20"
        cy="22"
        cx="22"
        height="200"
        width="200"
      ></circle>
    </svg>
  </>
);

export { ArchimateShapes };

